module.exports = __webpack_public_path__ + "static/media/brazil-flag.aa45dd46.png";